import React from "react";
import { Box, Typography, Paper, Grid, Chip, Divider } from "@mui/material";
import { AccessTime, Business, Title } from "@mui/icons-material";
import { Process, Service } from "../../../api/processes";

interface ProcessDetailsProps {
  process: Process;
  services: Service[];
}

export function ProcessDetails({ process, services }: ProcessDetailsProps) {
  const service = services.find((s) => s.id === process.serviceRef);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("fa-IR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {process.title}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <Title sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                شناسه فرایند:
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mr: 4 }}>
              {process.id}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <Business sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                خدمت مرتبط:
              </Typography>
            </Box>
            <Chip
              label={service?.name || "نامشخص"}
              color="primary"
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <AccessTime sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                تاریخ ایجاد:
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mr: 4 }}>
              {formatDate(process.createdOn)}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <AccessTime sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                آخرین تغییر:
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mr: 4 }}>
              {formatDate(process.modifiedOn)}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box>
          <Typography variant="h6" gutterBottom>
            اطلاعات تکمیلی
          </Typography>
          <Typography variant="body2" color="text.secondary">
            این فرایند در تاریخ {formatDate(process.createdOn)} ایجاد شده و
            آخرین بار در تاریخ {formatDate(process.modifiedOn)} بروزرسانی شده
            است.
            {service && ` این فرایند مربوط به خدمت "${service.name}" می‌باشد.`}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
